export default {
  header: {
    back: {
      url: 'http://chaumet.com/cht',
      content: '返回 Chaumet.com'
    }
  },
  playerCover: {
    title: 'CHAUMET世界',
    content: '2018 年 6 月 28 日至 9 月 17 日',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: '捲動以查看更多',
  worldDiscover: {
    title: {
      firstPart: '探索',
      secondPart: 'CHAUMET世界'
    },
    content:
      '東京三菱一號館美術館正舉辦展覽，邀請您探索CHAUMET歷史、文化、工藝與風格的全新旅程。',
    worlds: {
      types: [
        {
          title: '約瑟芬',
          content: 'Chaumet世家的繆斯女神。',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: 'Chaumet世家',
          content: '位於凡登廣場12號的第一位珠寶商。',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: 'Chaumet與日本',
          content: '旅途的邀約。',
          img: 'home/world/japon.jpg',
          url: 'japan'
        },
        {
          title: '自然物語',
          content: '取之不盡的靈感泉源。',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: '鑽冕藝術',
          content: '創意在心中。',
          img: 'home/world/art.jpg',
          url: 'tiara'
        },
        {
          title: '權力的象徵',
          content: '教皇庇護七世冠冕，權力的象徵。',
          img: 'home/world/pape.jpg',
          url: 'sovereigns'
        },
        {
          title: '情感珠寶',
          content: '可轉換式珠寶藝術',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: '見證美好的幸福時光 ',
          content: '世家精神與精湛工藝',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: '探索'
    },
    legend: 'CHAUMET世界'
  },
  wall: {
    title: 'CHAUMET世界',
    content:
      '本次展覽說明了CHAUMET如何從 19 世紀後半開始向全世界展開，並擷取多方的文化，向全世界訴說巴黎經典風格，並成為時尚歷史上不可或缺的要角。自 18 世紀末以來，CHAUMET向日本文化致敬，並且不斷保持著密切的聯繫。',
    previous: '向上',
    next: '向下',
    cta: 'see more',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: '重要資訊',
    exposition: {
      title: '「CHAUMET世界」展覽',
      content: '2018 年 6 月 28 日至 9 月 17 日，在東京三菱一號館美術館舉辦。'
    },
    museum: {
      link: {
        title: '進入展廳',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: '重要資訊',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/cht/home.js